export enum RecurrenceType {
  No = 0,
  Daily = 1,
  DailyWorkdays = 2,
  DailyWeekend = 3,
  Weekly = 4,
  BiWeekly = 5,
  EveryThirdWeek = 6,
  EveryFourthWeek = 7,
  MonthlyDayNumber = 8,
  MonthlyFirstDay = 9
}
